import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chartTypeError: {
		id: 'issue-field-statistics.numeric-stats-container-legacy.chart-type-error',
		defaultMessage: 'Invalid chart type. Please select a valid chart type from the options above.',
		description: 'Error message we display when the chart type is not supported',
	},
});
